import React from 'react';
import PropTypes from 'prop-types';
import { Record } from 'immutable';

import FeatureFlag from '../../general/FeatureFlag';
import CheckedOption from './CheckedOption';

export default function CheckedMarketingOption ({ form, flag, helpIconFeatureFlag, ...restProps }) {
    return (
        <FeatureFlag name={ flag }>
            <CheckedOption
                emailChecked={ form.get(restProps.emailField) }
                smsChecked={ form.get(restProps.smsField) }
                helpIconFeatureFlag={ helpIconFeatureFlag }
                { ...restProps } />
        </FeatureFlag>
    );
}

CheckedMarketingOption.propTypes = {
    form: PropTypes.instanceOf(Record).isRequired,
    flag: PropTypes.string,
    emailField: PropTypes.string,
    smsField: PropTypes.string,
    helpIconFeatureFlag: PropTypes.string,
};

CheckedMarketingOption.defaultProps = {
    flag: '',
    emailField: '',
    smsField: '',
    helpIconFeatureFlag: '',
};
